<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-12">
                    <np-checkbox v-if="!isView"
                                 :id="`${id}_selected`"
                                 :name="`${name}[selected]`"
                                 :no-wrapper="true"
                                 :disabled="itemIsDisabled(bundle_item)"
                                 :description="bundle_item.service.service_name"
                                 :checked="itemIsSelected(bundle_item)"
                                 v-model="dcc_activated"
                                 @change="selectDccFeatures(bundle_item)">
                    </np-checkbox>
                    <span v-else>   {{bundle_item.service.service_name}}</span>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="marginBottom10"  v-if="itemHasDescription(bundle_item)">
                        <span class="labelLook boldText">{{lang('description')}}</span>
                        <np-show-less
                            :id="id"
                            :description="bundle_item.service.service_description" >
                        </np-show-less>
                    </div>
                </div>
                <div class="col-12 col-sm-5 col-md-7 col-lg-7">
                    <div class="" v-if="itemHasFeatures(bundle_item)">
<!--                        <span class="labelLook boldText">{{lang('features')}}</span>-->
                        <div class="row">

                            <div class="col-lg-6 col-md-6 col-12"
                                        v-if="!!featureDictionary && !!featureDictionary.markUp && !!featureDictionary.markUp.is_visible">
                                <np-select2
                                        :label="featureDictionary.markUp.feature_name"
                                        :placeholder="featureDictionary.markUp.feature_name"
                                        :name="`${name}_markUp`"
                                        :required="featureDictionary.markUp.selected === '1'"
                                        :disabled="featureDictionary.markUp.selected !== '1' || featureDictionary.markUp.disabled || isView"
                                        :id="`${id}_markUp`"
                                        :key="`markUp`"
                                        :check_config="false"
                                        :help-text="loadHelpText('markUp')"
                                        @input="() => { validate(`#${id}_rebatePercent`);}"
                                        :parameters="getFeatureList(featureDictionary.markUp)"
                                        v-model="featureDictionary.markUp.value">
                                </np-select2>
                            </div>
                            <div class="col-lg-6 col-md-6 col-12"
                                        v-if="!!featureDictionary && !!featureDictionary.rebatePercent && !!featureDictionary.rebatePercent.is_visible">
                                <np-input
                                        :disabled="featureDictionary.rebatePercent.selected !== '1' || featureDictionary.rebatePercent.disabled || isView"
                                        :required="featureDictionary.rebatePercent.selected === '1'"
                                        :label="featureDictionary.rebatePercent.feature_name"
                                        :placeholder="featureDictionary.rebatePercent.feature_name"
                                        :name="`${name}_rebatePercent`"
                                        :id="`${id}_rebatePercent`"
                                        :key="`rebatePercent`"
                                        :check_config="false"
                                        :help-text="loadHelpText('rebatePercent')"
                                        :min="featureDictionary.rebatePercent.minimum"
                                        :max="markUpValue"
                                        v-model="featureDictionary.rebatePercent.value">
                                    <span slot="addon">%</span>
                                </np-input>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                    <div v-if="itemHasServiceCharges(bundle_item, isView)">
                        <span class="labelLook" style="font-weight: bold">{{lang('charges')}}</span>
                        <div class="row">
                            <template v-for="(service_charge, service_charge_idx) in bundle_item.service_charges">
                                <div class="col-12" v-if="!isView">
                                    <np-checkbox
                                            :id="`${id}_service_charge_${service_charge_idx}_selected`"
                                            :name="`${name}[service_charge][${service_charge_idx}][selected]`"
                                            :no-wrapper="true"
                                            :disabled="!bundle_item.selected"
                                            :description="getServiceChargeDescription(service_charge)"
                                            v-model="service_charge.selected">
                                    </np-checkbox>
                                </div>
                                <div class="col-12" v-else>
                            <span>
                              {{ getServiceCharge(service_charge) }}
                              {{ service_charge.service_frequency !== '1' ? `/${formatServiceFrequency(service_charge.service_frequency)}` : '' }}
                            </span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import utilMixin from "../utils/mixins";
    import applicationMixin from "../utils/application-mixin";
    import equipmentMixin from "../utils/equipment-mixin";
    import {Multiselect} from 'vue-multiselect';
    import Vue from 'vue';
    import {
        NPCheckBox,
        NPEntry,
        NPInput,
        NPNotice, NPPhone,
        NPRadios,
        NPResponsive,
        NPSelect2,
        NPSkeleton,
        NPShowLess

    } from "netpify/components";
    import NpMultiselect from "netpify/components/np-multiselect.vue";

    export default {
        name: "equipment-service-dcc",
        mixins: [utilMixin, applicationMixin, equipmentMixin],
        components: {
            'np-multiselect': NpMultiselect,
            'np-entry': NPEntry,
            'multiselect': Multiselect,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-select2': NPSelect2,
            'np-responsive': NPResponsive,
            'np-skeleton': NPSkeleton,
            'np-checkbox': NPCheckBox,
            'np-notice': NPNotice,
            'np-phone': NPPhone,
            'np-show-less': NPShowLess,
        },
        data() {
            return {
                featureList: [],
                dcc_activated: '',
            }
        },
        props: {
            bundle_item: {
                default() {
                    return {}
                }
            },
            isStandalone: Boolean,
            id: {
                default() {
                    return 'quote' + Math.random().toString()
                }
            },
            name: {
                default() {
                    return 'quote' + Math.random().toString()
                }
            },
            feature_dictionary: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            isView: Boolean,
            isBundlePackage: Boolean,
            bundlePackageSelected: Boolean,
        },
        mounted() {
            let vm = this
            this.featureList = this.getBundleItemFeatures(this.bundle_item);
            if (this.bundleItemIsSelected(this.bundle_item) || this.bundle_item.is_mandatory === '1') {
                this.selectDccFeatures(this.bundle_item);
            }
            setTimeout(function() {
                vm.dcc_activated = vm.bundle_item && vm.bundle_item.hasOwnProperty('is_boarding_activated') ?
                    vm.bundle_item.is_boarding_activated : '0';
            }, 500);
        },
        computed: {
            isDCCSeleced: function() {
                return this.dcc_activated === '1'
            },
            totalSellingOptions: function () {
                let total = 0.00;

                if (this.objectIsNotEmpty(this.bundle_item.service_charges)) {
                    let selected_service_charges = this.bundle_item.service_charges.filter(obj => obj.selected === '1');

                    selected_service_charges.forEach(obj => {
                        if (obj.service_frequency === '1') {
                            let value = !!obj.default_base_charge && obj.default_base_charge !== '' ? obj.default_base_charge :
                                !!obj.maximum_base_charge && obj.maximum_base_charge !== '' ? obj.maximum_base_charge : 0.00;
                            total = parseFloat(total) + parseFloat(value)
                        }
                    })
                }

                return this.convertToDecimal(total);
            },
            featureDictionary: function () {
                let feature_dictionary = {};
                this.featureList.forEach(feature => {
                    feature_dictionary[feature['feature_api_code']] = feature;
                });
                return feature_dictionary;
            },
            markUpValue: function () {
                let markUp = '';
                if (this.isSelectedFeature('rebatePercent')) {
                    markUp = this.featureDictionary.rebatePercent.maximum;
                }
                if (this.isSelectedFeature('markUp') && !!this.featureDictionary.markUp.value) {
                    let markUpText = this.featureListValuesDictionary[this.featureDictionary.markUp.value]['text'];
                    if (parseFloat(markUpText) <= this.featureDictionary.rebatePercent.maximum) {
                        markUp = markUpText;
                    }
                }
                return markUp;
            },
            featureListValuesDictionary: function () {
                // let featureListValues = Object.values(this.parameters['FEATURE_LIST_OF_LISTS_VALUES_PARAM']).find(obj => {
                //     return obj['feature_list_value_external_id'] === pciContact
                // });
                let feature_lists = this.parameters['FEATURE_LIST_OF_LISTS_VALUES_PARAM'];

                return feature_lists;
            }
        },
        methods: {
            loadHelpText: function(feature_api_code) {
                const tooltips = {
                    rebatePercent: 'equipment_services_dcc_rebate_percent',
                    markUp: 'equipment_services_dcc_markup'
                };

                const feature = this.featureDictionary[feature_api_code];
                if (!feature) return '';
                const defaultHelpText = feature.help_text || '';
                const tooltipKey = tooltips[feature_api_code] || '';
                return this.getTooltipText(tooltipKey, defaultHelpText);
            },
            itemHasDescription: function (bundle_item) {
                return bundle_item.service.hasOwnProperty('service_description') &&
                    bundle_item.service.service_description !== '';
            },
            itemIsDisabled: function (bundle_item) {
                return this.isView ? true : this.isBundlePackage ? true : this.equipmentIsDisabled(bundle_item);
            },
            onDccSelected: function(bundle_item) {
                let vm = this;

                bundle_item.selected = true;
                bundle_item.is_boarding_activated = '1';
                if (!bundle_item.hasOwnProperty('terminal_quantity') || bundle_item.terminal_quantity < 1) {
                    bundle_item.terminal_quantity = '1';
                }
            },
            onDccDeSelected: function(bundle_item) {
                let vm = this;

                bundle_item.selected = false;
                bundle_item.is_boarding_activated = '0';
                bundle_item.terminal_quantity = '0';
                bundle_item.service_charges.forEach(obj => obj.selected = '');
                if (vm.objectIsNotEmpty(bundle_item.service_features)) {
                    vm.getBundleItemFeatures(bundle_item).forEach(obj => {
                        obj.selected = '';
                        let collect_on_boarding = obj.hasOwnProperty('collect_on_boarding')
                            && obj.collect_on_boarding === vm.collect_on_boarding_types.BOARDING;

                        if (collect_on_boarding) {
                            obj.value = '';
                        }
                    })
                }
            },
            selectDccFeatures: function (bundle_item) {
                let vm = this;

                if (vm.dcc_activated === '0') {
                    vm.onDccDeSelected(bundle_item);
                } else if (vm.dcc_activated === '1') {
                    vm.onDccSelected(bundle_item);
                }

                if (this.featureDictionary.hasOwnProperty('rebatePercent')) {
                    this.featureDictionary['rebatePercent']['selected'] = '1';
                    this.selectItem('rebatePercent')
                }
                if (this.featureDictionary.hasOwnProperty('markUp')) {
                    this.featureDictionary['markUp']['selected'] = '1';
                    this.selectItem('markUp')

                    //select first value of markup as value
                    let values = this.featureDictionary['markUp'].value.split(',');
                    if (values.length > 1) {
                        this.featureDictionary['markUp'].value = values[0];
                    }
                }
            },
            selectItem: function (item, is_required = false) {
                if (this.featureDictionary.hasOwnProperty(item)) {
                    //set value on select
                    this.featureDictionary[item]['value'] = !!this.featureDictionary[item]['value'] ? this.featureDictionary[item]['value'] :
                        this.featureDictionary[item].hasOwnProperty('collect_on_value') ?
                            this.featureDictionary[item]['collect_on_value'] : this.featureDictionary[item]['default_value'];

                    //set the disabled field based on collect_on_boarding
                    if (this.featureDictionary[item]['collect_on_boarding'] === this.collect_on_boarding_types.OFFER) {
                        this.featureDictionary[item]['disabled'] = true
                    } else if (this.featureDictionary[item]['collect_on_boarding'] === this.collect_on_boarding_types.CONFIG) {
                        this.featureDictionary[item]['disabled'] = true;
                    } else {
                        this.featureDictionary[item]['disabled'] = false;
                    }

                    this.featureDictionary[item]['selected'] = '1';

                    if (!!is_required){
                        this.featureDictionary[item]['is_required'] = '1';
                    }
                }

                // if(this.featureDictionary[item]['collect_on_boarding'] ===  this.collect_on_boarding_types.OFFER) {
                //     this.featureDictionary[item]['value'] = this.featureDictionary[item]['collect_on_value'];
                //     this.featureDictionary[item]['disabled'] = true;
                // }
            },
            prepFeatureDictionary: function (bundle_item) {
                let bundle_item_features = this.getBundleItemFeatures(bundle_item);
                let feature_dictionary = {};
                bundle_item_features.forEach(feature => {
                    feature_dictionary[feature['feature_api_code']] = feature;
                });
                return feature_dictionary;
            },
            isSelectedFeature: function (feature_api_code) {
                if (this.featureDictionary.hasOwnProperty(feature_api_code) && this.featureDictionary[feature_api_code]['selected'] === '1') {
                    return true;
                }
                return false;
            },
            validateFeatureList: function () {
                //if pciContact is pre-populate
               let rebatePercent = this.featureDictionary.rebatePercent.value;

                if (this.featureDictionary.hasOwnProperty('markUp')) {

                }
            },
            itemIsSelected: function (bundle_item) {
                return this.isBundlePackage ? this.bundlePackageSelected ? '1' : '0' : this.equipmentIsSelected(bundle_item);
            },
            getServiceChargeDescription: function (service_charge) {
                return service_charge.service_item_name + ' - ' + this.getServiceCharge(service_charge) + (service_charge.service_frequency !== '1' ? `/${this.formatServiceFrequency(service_charge.service_frequency)}` : '');
            },
            getFeatureValue: function (feature) {
                let feature_value = !!feature.value ? feature.value : feature.default_value

                if (feature.feature_input_type === this.types.LIST) {
                    let feature_list = this.getFeatureList(feature);
                    let matched_value = feature_list.find(obj => obj.id === feature_value);

                    return !!matched_value ? `(${matched_value.text})` : '';
                } else {
                    return feature_value !== '' ? `(${feature_value})` : '';
                }
            }
        }
    }
</script>

<style scoped>
    ul:not(.nav-pills) {
        list-style: none;
    }

    li:not(.nav-item) {
        font-weight: lighter;
        font-size: 0.8em;
    }

    li:not(.nav-item):before {
        content: "\f054"; /* FontAwesome Unicode fa-chevron-right*/
        font-family: 'Font Awesome 5 Free';
        font-weight: 900;
        display: inline-block;
        margin-left: -1.3em; /* same as padding-left set on li */
        width: 1.3em; /* same as padding-left set on li */
    }

    /*.avatar-small:hover {*/
    /*    box-shadow: 0 0 2px 1px rgba(66, 153, 225, 1);*/
    /*    -ms-transform: scale(2.5); !* IE 9 *!*/
    /*    -webkit-transform: scale(2.5); !* Safari 3-8 *!*/
    /*    transform: scale(2.5);*/
    /*    cursor: pointer;*/
    /*    z-index: 99999;*/
    /*}*/

    .vue-radio-checkbox.np-checkbox.default.form-group {
        min-height: 0 !important;
    }


</style>
